import type { NutritionPanel } from '../../types'
import { NUTRIENTS } from '../../types'
import { NUTRIENT_LABELS, nutrient } from '../../utils/intake'

// Shown in the headline (kcal + macros), so excluded from the detail list.
const HEADLINE = new Set(['calories', 'protein', 'carbs', 'fat'])

const fmt = (v: number) => (v >= 10 ? Math.round(v) : Math.round(v * 10) / 10)

/** Wrapped list of every populated nutrient beyond the headline macros. */
export default function NutritionDetails({ panel }: { panel: NutritionPanel }) {
  const rows = NUTRIENTS.filter((n) => !HEADLINE.has(n) && nutrient(panel, n) > 0)
  if (rows.length === 0) {
    return <p className="text-xs text-[var(--text-secondary)]">No further nutrition details estimated.</p>
  }
  return (
    <div className="flex flex-wrap gap-x-3 gap-y-1 text-xs text-[var(--text-secondary)]">
      {rows.map((n) => {
        const meta = NUTRIENT_LABELS[n]
        return (
          <span key={n}>
            {meta.label}{' '}
            <span className="text-[var(--text-primary)]">
              {fmt(nutrient(panel, n))}
              {meta.unit}
            </span>
          </span>
        )
      })}
    </div>
  )
}
